function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.66326 3.52578C5.56761 4.82697 4.91215 5.60257 4.13722 6.76013C3.57002 7.60596 2.8177 8.73798 2.14287 10.3349C1.65101 11.4978 1.20758 12.5352 1.06659 13.8459C0.984788 14.6066 0.660826 17.6112 2.78864 20.1231C5.06391 22.8096 8.41223 22.8893 8.92346 22.8893H8.87288C9.38519 22.8893 12.7324 22.8096 15.0077 20.1231C17.1355 17.6112 16.8115 14.6066 16.7297 13.8459C16.592 12.5607 16.1679 11.5595 15.6535 10.3349C15.1023 9.04132 14.417 7.80766 13.6085 6.65374C12.9089 5.62172 12.317 4.92272 11.1331 3.52578C10.2279 2.45759 9.44869 1.5958 8.89763 1C8.32827 1.61283 7.5512 2.47035 6.66326 3.52578Z",
  stroke: "current",
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.02955 14.5268C4.01487 15.7628 4.43316 16.9656 5.21346 17.9314C6.54482 19.555 8.38742 19.8039 8.7652 19.8465",
  stroke: "current",
  strokeMiterlimit: 10
});

function SvgLiquidLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquidLogo);
export default __webpack_public_path__ + "static/media/liquidLogo.377c7f1a.svg";
export { ForwardRef as ReactComponent };